import React, { Fragment, useEffect, useState } from "react";
import "./Notification.scss";
import { selectIcon, SVG } from "../UI/selector";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { onMessage } from "firebase/messaging";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Firebase, messaging } from "../../services/firebase";
import { toast } from "react-toastify";
import { profileActions } from "../../store";
import { ErrorUI } from "../UI/Modals/Modals";
import {
  readNotification,
  clearNotifications,
  listNotifications,
  updateDefaultGym,
} from "../../services/CallApi";
import OutsideAlerter from "../UI/OutsideAlerter/OutsideAlerter";
import { NotificationDropdown } from "./NotificationDropdown/NotificationDropdown";

export const NotificationUI = ({}) => {
  const { notifications, defaultGym } = useSelector(
    (state) => state.profile.profileData
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const [isNotificationShowing, setNotificationShowing] = useState(false);
  const [notifOpened, setNotifOpened] = useState(true);

  useEffect(() => {
    getNotifications();
  }, [defaultGym]);

  const bc = new BroadcastChannel("notifications");
  useEffect(() => {
    bc.onmessage = (ev) => {
      addNewNotification(ev.data);
    };
    return () => {
      bc.close();
    };
  }, []);

  useEffect(() => {
    onNotification()
      .then((payload) => {
        console.info("Message received. ", payload);
        addNewNotification(payload);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const onNotification = () =>
    new Promise((resolve) =>
      onMessage(messaging, (payload) => resolve(payload))
    );

  const addNewNotification = (payload, popup) => {
    const newNotification = {
      notification_id: payload.data.notification_id,
      message: payload.notification.body,
      created_at: new Date().toISOString(),
      notification_type: payload.data.notification_type,
      gym_id: payload.data.gym_id,
    };
    toast.info(
      <p onClick={() => _readNotification(newNotification)}>
        {newNotification.message}
      </p>
    );
    let newNotifications = [newNotification];
    if (notifications && notifications.length) {
      newNotifications = [newNotification, ...notifications];
    }
    dispatch(
      profileActions.updateProfileData({
        notifications: newNotifications,
      })
    );
  };

  const getNotifications = () => {
    listNotifications({ limit: 20, offset: 0 }).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData({ notifications: res.data }));
      } else {
        ErrorUI(res.list, () => getNotifications());
      }
    });
  };

  const isUnreadNotifications =
    notifications && notifications.length
      ? notifications.find((el) => {
          return el.read_at ? false : true;
        })
      : false;
  const updateNewDefaultGym = (id) => {
    updateDefaultGym(id).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data));
      } else {
        ErrorUI(res.list, () => {
          updateNewDefaultGym(id);
        });
      }
    });
  };

  const viewNotif = () => {
    setNotificationShowing(!isNotificationShowing);
    setNotifOpened(false);
  };

  const _readNotification = (notification) => {
    readNotification(notification.notification_id).then((res) => {
      if (res.status) {
        let route = "/Home";
        switch (notification.notification_type) {
          case "NEW_ACTIVITY_SCHEDULED":
            route = "/LiveAndUpcoming";
            break;
          case "NEW_ONDEMAND_ACTIVITY_ADDED":
            route = "/OndemandScreen";
            break;
          case "GYM_LINK_DEACTIVATED":
            route = "/Studios";
            break;
          case "GYM_LINK_APPROVED":
            route = "/Home";
            break;
          default:
            break;
        }
        history.push(route);
        updateNewDefaultGym(notification.gym_id);
      } else {
        ErrorUI(res.list, () => _readNotification(notification));
      }
    });
  };

  const clearAll = () => {
    clearNotifications().then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData({ notifications: [] }));
      } else {
        ErrorUI(res.list, () => clearAll);
      }
    });
  };

  return (
    <Fragment>
      <Firebase />
      <OutsideAlerter clickOutSide={() => setNotificationShowing(false)}>
        <div className="iconDiv" onClick={viewNotif}>
          {isUnreadNotifications && notifOpened ? (
            <div className="unreadNtificationCircle"></div>
          ) : null}
          <SVG src={selectIcon("bellIcon")} />
        </div>
        {isNotificationShowing ? (
          <NotificationDropdown
            meta_id="user_profile_click"
            closeDropdown={() => setNotificationShowing(!isNotificationShowing)}
            notifications={notifications}
            onClear={clearAll}
            onNotificationClick={(notification) =>
              _readNotification(notification)
            }
          />
        ) : null}
      </OutsideAlerter>
    </Fragment>
  );
};

export function Notification({ notification, onClick }) {
  return (
    <div
      className={
        "notification_container" + (notification.read_at ? "" : " unread")
      }
      onClick={onClick}
    >
      <p>{notification.message}</p>
      <div className="notification_date">
        <SVG src={selectIcon("watch")} height={15} />
        {moment(notification.created_at).format("MMM D, h:mm A")}
      </div>
    </div>
  );
}
